import React, {useState} from "react";
import {Dialog, Transition} from "@headlessui/react";
import {ArrowLeftIcon, XMarkIcon} from "@heroicons/react/24/outline";
import {useLocation} from "react-router-dom";
import axios from "axios";
import {useQuery} from "react-query";

const AssignRiderModal = ({
  isOpen,
  closeModal,
  id,
  jobId,
}: {
  isOpen: boolean;
  closeModal: () => void;
  id: string;
  jobId: string;
}) => {
  const location = useLocation();
  const Baseurl = process.env.REACT_APP_BASEURL;
  const token = JSON.parse(localStorage.getItem("eftd-admin-token") || "{}")
    ?.data?.data?.token;
  const [isLoading, setIsLoading] = useState(false);

  const [currentPage] = useState(Number(location.search.slice(-1)) || 1);

  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };

  const getRiders = async () => {
    const response = await axios.get(
      `${Baseurl}/api/admin/orders/riders?limit=10&page=${currentPage}`,
      {...config}
    );
    return response?.data?.data;
  };

  const {data: riders, isLoading: isLoadingRiderData} = useQuery(
    ["RIDERS", currentPage],
    getRiders
  );
  const [selectedRiders, setSelectedRiders] = useState<any[]>([]);
  const handleSelectRiders = (user: any) => {
    setSelectedRiders((prev) => {
      if (prev.some((rider: any) => rider.fleet_id === user.fleet_id)) {
        return [];
      } else {
        return [user];
      }
    });
  };
  const assignRider = async () => {
    if (selectedRiders.length === 0) return;

    const payload = {
      rider_id: String(selectedRiders[0].fleet_id),
      team_id: String(selectedRiders[0].team_id),
      tasks: [
        {
          order_id: id,
          task_id: jobId,
        },
      ],
    };
    setIsLoading(true);
    try {
      await axios.post(
        `${Baseurl}/api/admin/orders/deliveries/assign`,
        payload,
        {
          ...config,
        }
      );
      closeModal();
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Transition appear show={isOpen} as={React.Fragment}>
      <Dialog as="div" className="relative z-50" onClose={closeModal}>
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/20 bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full !m-4 !rounded-[20px] overflow-hidden bg-white">
              <Transition.Child
                as={React.Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-md !px-4 !py-6 flex flex-col justify-between  overflow-hidden">
                  <button
                    className="flex items-center gap-2 !mb-6"
                    onClick={closeModal}
                  >
                    <ArrowLeftIcon width={24} height={24} color="#666D80" />
                    <p className="!text-sm text-[#666d80]">Go Back</p>
                  </button>
                  {/* Header */}
                  <div className="px-4 py-6 sm:px-6">
                    <div className="flex items-start justify-between">
                      <Dialog.Title className="text-xl font-semibold leading-6 text-gray-900">
                        Assign Rider To Order
                      </Dialog.Title>
                    </div>
                    <p className="mt-2 !text-sm text-gray-400">
                      We are looking for the closest driver for you...
                    </p>
                  </div>

                  {isLoadingRiderData ? (
                    <div
                      className="grow flex items-center justify-center animate-pulse
"
                    >
                      <img src={"/rider.svg"} alt="" />
                    </div>
                  ) : riders?.length === 0 ? (
                    <>
                      <div className="grow flex flex-col items-center justify-center">
                        <img
                          src={"/motorcycle.svg"}
                          alt=""
                          className="w-[60px] h-[60px]"
                        />
                        <p className="text-lg font-medium text-[#272835] !mt-2 !mb-4">
                          No rider available
                        </p>

                        <button className="flex items-center gap-1 !mb-4">
                          <span className="!text-sm font-semibold text-[#fe7f1f]">
                            Refresh List
                          </span>
                          <span>
                            <img
                              src={"/refresh.svg"}
                              alt=""
                              className="w-4 h-4"
                            />
                          </span>
                        </button>

                        <p className="text-sm font-semibold text-[#666d80]">
                          Manually assign rider ?
                        </p>
                      </div>

                      <button className="w-full bg-[#f8fafb] rounded-[10px] text-[#666d80] font-bold !py-4">
                        Cancel
                      </button>
                    </>
                  ) : (
                    <div className="grow pt-4 flex flex-col justify-between gap-6 w-full overflow-hidden">
                      <div className="flex items-center justify-between !mt-8">
                        <p className="!text-sm font-semibold text-[#666d80]">
                          Available Riders{" "}
                          <span className="text-black">(20)</span>
                        </p>

                        <button className="flex items-center gap-1">
                          <span className="!text-sm font-semibold text-[#fe7f1f]">
                            Refresh List
                          </span>
                          <span>
                            <img
                              src={"/refresh.svg"}
                              alt=""
                              className="w-4 h-4"
                            />
                          </span>
                        </button>
                      </div>
                      <div className="flex flex-col w-full gap-4 grow overflow-y-auto">
                        {riders?.map((user: any, index: number) => (
                          <div key={user.fleet_id} className="!px-4 !mb-2">
                            <input
                              type="checkbox"
                              id={user.fleet_id}
                              name="user"
                              value={user.fleet_id}
                              className="hidden"
                              checked={selectedRiders.includes(user.fleet_id)}
                              onChange={() => handleSelectRiders(user)}
                            />
                            <label
                              htmlFor={user.fleet_id}
                              className={`flex items-center gap-4 !p-4 rounded-lg border ${
                                selectedRiders.includes(user.fleet_id)
                                  ? "!border-[#FE7F1F]"
                                  : "border-gray-200"
                              } bg-white cursor-pointer transition-colors duration-200 relative`}
                            >
                              <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-200"></div>
                              <div className="space-y-1 flex-1">
                                <p className="!text-sm font-semibold text-black">
                                  {user.name}
                                </p>
                                <div className="flex items-center gap-1">
                                  <svg
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M2.5 9.5C3.60457 9.5 4.5 8.60457 4.5 7.5C4.5 6.39543 3.60457 5.5 2.5 5.5C1.39543 5.5 0.5 6.39543 0.5 7.5C0.5 8.60457 1.39543 9.5 2.5 9.5Z"
                                      stroke="black"
                                      strokeWidth="0.75"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M9.5 7.5L8 3L8.5 2.5"
                                      stroke="black"
                                      strokeWidth="0.75"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M8 4.25L5.75 4.25L3.5 5.75"
                                      stroke="black"
                                      strokeWidth="0.75"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M2.75 7.75L6 7.75L6.5 6.5L8.25 4.25"
                                      stroke="black"
                                      strokeWidth="0.75"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M4.25 5.00001C3.25 4.25 1.75 4.25 0.75 5.00001"
                                      stroke="black"
                                      strokeWidth="0.75"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M9.5 9.5C10.6046 9.5 11.5 8.60457 11.5 7.5C11.5 6.39543 10.6046 5.5 9.5 5.5C8.39543 5.5 7.5 6.39543 7.5 7.5C7.5 8.60457 8.39543 9.5 9.5 9.5Z"
                                      stroke="black"
                                      strokeWidth="0.75"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                  <span className="!text-xs text-black/50 font-semibold">
                                    {user.timeAway}
                                  </span>
                                </div>
                              </div>
                              <div className="w-4 h-4 rounded-full border-2 border-gray-300 transition-colors duration-200 flex items-center justify-center">
                                {selectedRiders.includes(user) && (
                                  <div className="w-2 h-2 rounded-full bg-[#FE7F1F]"></div>
                                )}
                              </div>
                            </label>
                          </div>
                        ))}
                      </div>
                      <div className="flex items-center justify-between">
                        <button className="bg-[#FFF0F3] rounded-[10px] text-[#DF1C41] font-bold !py-4 !px-10 !text-sm">
                          Cancel
                        </button>
                        <button
                          onClick={assignRider}
                          className="bg-[#FE7F1F] rounded-[10px] text-white font-bold !py-4 !px-10 !text-sm"
                        >
                          {isLoading ? "Loading..." : "Assign Rider"}
                        </button>
                      </div>
                    </div>
                  )}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default AssignRiderModal;
